module.exports = "https://static.wanderu.com/ui-react/_next/static/media/wanderu_exclusive_small_peek_prod.a4b9109a.png";